
  <template>
    <div>
      <a href="#" @click="prevDate">&laquo;</a> {{currentMonth}} ({{currentYear}}) <a href="#" @click="nextDate">&raquo;</a>
    </div>
  </template>

<script>

  var currentDate = new Date();
  var currentMonth = "initial";
  var currentYear = "initial";
  var onChangeHandler = null;

  import moment from 'moment'

	export default {
    name: 'input-month-selector',
		components: {
    },
    props: {
     

    },
    methods: {
      prevDate() {
        this.step(-1);
      },
      nextDate() {
        this.step(1);
      },
      step(months) {
        var mom = new moment(this.currentDate);
        if (months < 0) {
          this.currentDate = mom.add(months, "month");
          mom = new moment(this.currentDate)
        }
        else if (months > 0) {
          this.currentDate = mom.add(months, "month");
          mom = new moment(this.currentDate)
        }
        this.currentMonth = mom.format('MMMM');
        this.currentYear = mom.format('YY');
        
        if (this.onChangeHandler != null) {
          this.onChangeHandler(mom.format('YY'), mom.format('MM'));
        }
          
      },
      onChange(handler) {
        this.onChangeHandler = handler;
      }
      
    },
    data() {
      return {
        currentDate,
        currentMonth,
        currentYear,
        onChangeHandler
      }
    },
    created() {
      
    },
    mounted() {
      this.step(0);
    },
    computed: {
      
    },
    watch: {
      
    }
}
</script>



// WEBPACK FOOTER //
// src/components/form-components/input-month-selector.vue